import React, { useEffect } from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Link,
  PDFViewer,
  Font,
  PDFDownloadLink,
  pdf,
} from "@react-pdf/renderer";
import { getImageUrl, getUrl_PDF } from "../../../MIS/Global";
import { decrypt, encrypt } from "../../../MIS/encryption";
import { useParams } from "react-router-dom";
import { useState } from "react";
import { apiAdd } from "../../../API/Service/apiClient";

/* ================= STYLES ================= */
Font.register({
  family: "NotoSans",
  fonts: [
    {
      src: "https://raw.githubusercontent.com/googlefonts/noto-fonts/main/hinted/ttf/NotoSans/NotoSans-Regular.ttf",
    },
    {
      src: "https://raw.githubusercontent.com/googlefonts/noto-fonts/main/hinted/ttf/NotoSans/NotoSans-Bold.ttf",
      fontWeight: "bold",
    },
  ],
});
const styles = StyleSheet.create({
  page: {
    padding: 15,
    fontSize: 9,
    fontFamily: "NotoSans",
  },

  /* HEADER */
  headerWrapper: {
    backgroundColor: "#e6f2ff",
    padding: 12,
    borderRadius: 6,
    marginBottom: 12,
    position: "relative",
  },

  companyName: {
    fontSize: 14,
    fontWeight: "bold",
    marginBottom: 3,
  },

  companyInfo: {
    fontSize: 9,
    marginBottom: 1,
  },

  badge: {
    position: "absolute",
    top: 10,
    right: 12,
    backgroundColor: "#333",
    color: "#fff",
    fontSize: 10,
    paddingVertical: 3,
    paddingHorizontal: 8,
    borderRadius: 20,
    fontWeight: "bold",
  },

  dateText: {
    fontSize: 8,
    marginTop: 4,
  },

  /* ================= CATEGORY HEADINGS ================= */

  categoryWrapper: {
    marginBottom: 15,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-end",
  },

  leftHeadingBlock: {
    flexDirection: "column",
  },

  mainHeading: {
    fontSize: 14,
    fontWeight: "bold",
  },

  subHeading: {
    fontSize: 12,
    marginTop: 2,
  },

  subSubHeading: {
    fontSize: 11,
    color: "gray",
  },

  /* GRID */
  productGrid: {
    flexDirection: "row",       // 🔥 changed
    flexWrap: "wrap",           // 🔥 allow wrapping
    justifyContent: "space-between",
  },

  /* CARD */
  productCard: {
    flexDirection: "row",       // image left + info right
    marginBottom: 20,
    width: "44%",               // 🔥 2 per row
  },

  productImage: {
    width: 120,
    height: 120,
    objectFit: "contain",
    marginRight: 10,
  },

  /* RIGHT SIDE INFO */
  productDetails: {
    flex: 1,
    justifyContent: "flex-start",
  },

  priceRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 6,
    paddingBottom: 4,
    borderBottom: "1 solid #eee",
  },
  
  /* LEFT SIDE (MRP) */
  mrpLabel: {
    fontSize: 7,
    color: "gray",
  },
  
  mrpValue: {
    fontSize: 9,
    textDecoration: "line-through", // 🔥 nice discount feel
    color: "#888",
  },
  
  /* RIGHT SIDE (YOUR PRICE) */
  priceRight: {
    alignItems: "flex-end",
  },
  
  yourPriceLabel: {
    fontSize: 7,
    color: "gray",
  },
  
  yourPrice: {
    fontSize: 11,
    fontWeight: "bold",
    color: "#000",
  },

  meta: {
    fontSize: 9,
    marginBottom: 1,
  },
  textBold: {
    fontSize: 9,
    fontWeight: "bold",
  },
   
  stock: {
    fontSize: 8.5,
    marginTop: 3,
  },

  sizes: {
    fontSize: 8,
    marginTop: 2,
  },

  footer: {
    position: "absolute",
    bottom: 10,
    left: 0,
    right: 0,
    textAlign: "center",
    fontSize: 8,
    color: "gray",
  },

  /* ================= REMARK ================= */

  remarkSection: {
    marginTop: 25,
    backgroundColor: "#f4f9ff",
    padding: 12,
    borderRadius: 6,
  },

  remarkText: {
    fontSize: 10,
  },
});

/* ================= DOCUMENT ================= */

const CatalogueDocument = ({ data = {}, products = [], compressedImages = {} }) => {
  
  const calculateYourPrice = (mrp, value, type) => {
    if (!mrp || !value) return mrp || 0;
  
    let discount = 0;
  
    if (type === "value") {
      // direct minus
      discount = value;
    } else if (type === "percent") {
      // calculate percentage
      discount = (mrp * value) / 100;
    }
  
    const finalPrice = mrp - discount;
  
    // prevent negative price
    return finalPrice > 0 ? Number(finalPrice).toFixed(2) : 0;
  };

  const handle_navigate = (element) =>{
    // alert(JSON.stringify(element))
    return `${getUrl_PDF()}tbkDetail/${encrypt(element?.id)}/${encrypt(element?.subid)}`    
    // return `${getUrl_PDF()}tbkDetail/${encrypt(element?.id)}/${encrypt(element?.subid)}}`;
  }

  const productList = products.length
    ? products
    : [
        {
          id: 1,
          img: "https://jcbk.teeblanka.com/api/media/subProduct/TEE_BLANKA_CAPS.png",
          mrp: 1699,
          price: 475,
          style: "NF-OT-OR /DN-3275",
          color: "ORANGE",
          brand: "RN- OVERSIZE TSHIRT",
          category: "BUILD YOUR BRAND",
          stock: 1238,
          sizes: "S:150 M:315 L:340 XL:239 2XL:152 3XL:42",
        },         
      ];

  return (
    <Document title="Product Catalogue"
    fileName="test"
    >
      <Page size="A4" style={styles.page} wrap>

        {/* HEADER */}
        <View style={styles.headerWrapper}>
          <Text style={styles.companyName}>
            {data?.companyName || "Tee Blanka"}
          </Text>
          <Text style={styles.companyInfo}>
            {data?.fullName || "Owner Name"}
          </Text>
          <Text style={styles.companyInfo}>
            {data?.contact || "9876543210"}
          </Text>

          <Text style={styles.companyInfo}>
            {[data?.building, data?.road]
                  .filter(Boolean)
                  .join(" ")}            
          </Text>

          {/* <Text style={styles.dateText}>
            {new Date().toLocaleDateString()}{" "}
            {new Date().toLocaleTimeString()}
          </Text> */}

          <View style={styles.badge}>
            <Text>{productList.length} Products</Text>
          </View>
        </View>

        <View style={styles.categoryWrapper}>
            
            {/* Left side: main + sub */}
            <View style={styles.leftHeadingBlock}>
              {data?.mainHeading && (
                <Text style={styles.mainHeading}>{data?.mainHeading}</Text>
              )}
              {data?.subHeading && (
                <Text style={styles.subHeading}>{data?.subHeading}</Text>
              )}
            </View>

            {/* Right side: subSub */}
            {data?.subSubHeading && (
              <Text style={styles.subSubHeading}>{data?.subSubHeading}</Text>
            )}
          </View>

        {/* PRODUCTS */}
        <View style={styles.productGrid}>
          {productList.map((item, index) => (
            <View key={index} style={styles.productCard} wrap={false}>

              {/* IMAGE */}
              <Link src={handle_navigate(item)}>
                <Image style={styles.productImage}
                 onClick
                 src={compressedImages[item.id] || getImageUrl(`/media/${item?.imgpath}`)}
                 />
              </Link>

              {/* DETAILS */}
              <View style={styles.productDetails}>
              <View style={styles.priceRow}>
                <View>
                  <Text style={styles.mrpLabel}>MRP</Text>
                  <Text style={styles.mrpValue}>
                    ₹{item.min_mrp}
                  </Text>
                </View>

                <View style={styles.priceRight}>
                  <Text style={styles.yourPriceLabel}>Your Price</Text>
                  <Text style={styles.yourPrice}>
                    ₹{calculateYourPrice(item?.min_mrp, data?.marginValue, data?.marginType)}
                  </Text>
                </View>
              </View>     

                <Text style={styles.meta}>
                   <Text style={styles.textBold}>{item?.productname}</Text>
                </Text>
                <Text style={styles.meta}>
                  Code: <Text style={styles.textBold}>{item?.productcode}</Text>
                </Text>

                <Text style={styles.meta}>
                  Colour: <Text style={styles.textBold}>{item?.productcolor}</Text>
                </Text>             

                <Text style={styles.meta}>
                  Category: <Text style={styles.textBold}>{item?.mpname}</Text>
                </Text>

                {/* <Text style={styles.stock}>
                  Total Stock: {item.stock}
                </Text>

                <Text style={styles.sizes}>
                  {item.sizes}
                </Text> */}
              </View>

            </View>
          ))}
        </View>

        {data?.remarks && (
          <View style={styles.remarkSection}>
            <Text style={styles.remarkText}>{data?.remarks}</Text>
          </View>
        )}

        {/* FOOTER */}
        <Text style={styles.footer}>
          Generated on {new Date().toLocaleString()}
        </Text>

      </Page>
    </Document>
  );
};

/* ================= VIEWER ================= */

const ProductCataloguePDF = (props) => {
  const { data } = useParams();
  const [para, setPara] = useState({})
  const [loading, setLoading] = useState(false)
  const [pdfReady, setPdfReady] = useState(false); 
  const [dataList, setDataList] = useState([])
  const [compressedImages, setCompressedImages] = useState({});
  const [pdfUrl, setPdfUrl] = useState(null);

  let parsedData = {};
  const compressImage = (url, quality = 0.6, maxWidth = 400) => {
    return new Promise((resolve) => {
      const img = new window.Image();
      img.crossOrigin = "Anonymous"; // important for CORS
  
      img.onload = () => {
        const canvas = document.createElement("canvas");
  
        const scale = maxWidth / img.width;
        const width = maxWidth;
        const height = img.height * scale;
  
        canvas.width = width;
        canvas.height = height;
  
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);
  
        // convert to compressed base64 (JPEG)
        const compressedBase64 = canvas.toDataURL("image/jpeg", quality);
  
        resolve(compressedBase64);
      };
  
      img.src = url;
    });
  };

  const prepareCompressedImages = async (products) => {
    let map = {};
  
    for (let item of products) {
      const originalUrl = getImageUrl(`/media/${item?.imgpath}`);
  
      try {
        const compressed = await compressImage(originalUrl, 0.6, 400);
        map[item.id] = compressed;
      } catch (e) {
        map[item.id] = originalUrl; // fallback
      }
    }
  
    setCompressedImages(map);
  };
  const generatePDFPreview = async () => {
    try {
      const blob = await pdf(
        <CatalogueDocument
          data={para}
          products={dataList}
          compressedImages={compressedImages}
        />
      ).toBlob();
  
      const url = URL.createObjectURL(blob);
      setPdfUrl(url);
    } catch (err) {
      console.error("PDF preview error", err);
    }
  };
  const handleGeProduct_list = async () => {    
    let filter={page:1, limit:1000, 
      subid:para?.subId,
      action: "getProducts" };
    setLoading(true);
    setPdfReady(false);

    try {
      const resData = await apiAdd("tbk-product", {...filter});    
      setDataList(resData?.data)
      await prepareCompressedImages(resData?.data);
    } catch (error) {
      // console.log("Something went wrong! Please try again", "danger");
    } finally {
      setLoading(false);
      setTimeout(async () => {
          // 🔥 IMPORTANT
        setPdfReady(true);
      }, 800);
    }
  };
  useEffect(() => {
    const handlePDF = async () => {
      if (pdfReady === true) {
        await generatePDFPreview();
        // setPdfReady(false);
      }
    };
  
    handlePDF();
  }, [pdfReady]);
 
  useEffect(() => {
    try {
      const decoded = decodeURIComponent(data);     // 🔥 decode URL
      const decrypted = decrypt(decoded);           // 🔥 decrypt
      parsedData = JSON.parse(decrypted); 
      setPara(parsedData);
            // 🔥 convert back to object
    } catch (err) {
      console.error("Invalid data", err);
    }
  }, [])
  useEffect(() => {
    if (para && Object.keys(para).length > 0 && dataList.length <= 0) {
      handleGeProduct_list();
    }
  }, [para])
  return (
    <>
    {/* LOADER */}
    {(loading || !pdfReady) && (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          background: "#fff",
          zIndex: 999
        }}
      >
        <div className="text-center">
          <div className="spinner-border text-primary" role="status" />
          <div style={{ marginTop: 10 }}>Preparing PDF...</div>
        </div>
      </div>
    )}

    {/* ✅ DESKTOP VIEW */}
    {/* {pdfReady && pdfUrl && !/iPhone|iPad|iPod|Android/i.test(navigator.userAgent) && (
      <PDFViewer style={{ width: "100%", height: "100vh" }}>
        <CatalogueDocument
          data={para}
          products={dataList}
          compressedImages={compressedImages}
        />
      </PDFViewer>
    )} */}

    {/* ✅ MOBILE VIEW (REAL FIX) */}
    {/* {pdfReady && pdfUrl && /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) && ( */}
      <iframe
        src={pdfUrl}
        title="PDF Preview"
        style={{
          width: "100%",
          height: "100vh",
          border: "none"
        }}
      />
    {/* )} */}
  </>
  );
};

export default ProductCataloguePDF;